import type { CookieGtmAnalyticsChannels } from '@bcf-vanilla-ts-v1-logic-worker-others/bloc/cookie-gtm-analytics/cookie-gtm-analytics-channels';
import { UnsubscribableWithWorkerBlocForService } from '@bcf2-v1-platforms/platform-worker/browser/unsubscribable-with-worker-bloc-for-service';
import type { ReactiveControllerHost } from 'lit';
import type { GtmService } from './gtm.service';
import { provideGtmService } from './gtm.service';
import type { GtmCookieConsent } from './types';

export class GtmNotifierService extends UnsubscribableWithWorkerBlocForService<CookieGtmAnalyticsChannels> {
  constructor(
    private _gtmService: GtmService,
    host: ReactiveControllerHost
  ) {
    super(host);
    this._initWorkerBloc('cookie-gtm-analytics');
  }

  public override init(): void {
    this._sub = this._subTo('analyticsConsent').subscribe((consent: GtmCookieConsent) => {
      this._gtmService.gtag('consent', 'update', consent);
      this._gtmService.pushDataLayer('cookie-consent-update');
    });
  }
}

export function provideGtmNotifierService(host: ReactiveControllerHost): GtmNotifierService {
  return new GtmNotifierService(provideGtmService(), host);
}
